import * as React from 'react';

import { DiscountCodeActionContext, DiscountCodeValueContext } from './context';
import { useDiscountCodeAction, useDiscountCodeValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const DiscountCodeFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <DiscountCodeValueContext.Provider value={state}>
      <DiscountCodeActionContext.Provider value={dispatch}>
        {children}
      </DiscountCodeActionContext.Provider>
    </DiscountCodeValueContext.Provider>
  );
};

export { DiscountCodeFormContext, useDiscountCodeAction, useDiscountCodeValue };
